import api from "../../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchApplicationLogs = async (params = {}) => {
  const {
    page = 1,
    limit = 20,
    q,
    action,
    entity,
    user,
    addedByEmail,
    addedByName,
    donationNumber,
    ip,
    startDate,
    endDate,
  } = params;

  try {
    const response = await api({
      method: "GET",
      url: `${API_URL}/application-logs`,
      params: {
        page,
        limit,
        q,
        action,
        entity,
        user,
        addedByEmail,
        addedByName,
        donationNumber,
        ip,
        startDate,
        endDate,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching application logs:", error);
    throw error;
  }
};

export const fetchApplicationLogsCount = async (params = {}) => {
  const { q, action, entity, user, addedByEmail, addedByName, donationNumber, ip, startDate, endDate } =
    params;

  try {
    const response = await api({
      method: "GET",
      url: `${API_URL}/application-logs/count`,
      params: {
        q,
        action,
        entity,
        user,
        addedByEmail,
        addedByName,
        donationNumber,
        ip,
        startDate,
        endDate,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching application logs count:", error);
    throw error;
  }
};
